import { useTextField } from "@react-aria/textfield";
import { useMessageFormatter } from "@react-aria/i18n";
import _babelRuntimeHelpersEsmInteropRequireDefault from "@babel/runtime/helpers/esm/interopRequireDefault";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/ar-AE.json
var $c76317fc87652827db860fd78f41091$exports = {};
$c76317fc87652827db860fd78f41091$exports = JSON.parse("{\"Clear search\":\"مسح البحث\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/bg-BG.json
var $bdebbfdf67af8a25a6f22f0c45d8bf69$exports = {};
$bdebbfdf67af8a25a6f22f0c45d8bf69$exports = JSON.parse("{\"Clear search\":\"Изчистване на търсене\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/cs-CZ.json
var $dfe8bbb903ff9a9947d17929d43$exports = {};
$dfe8bbb903ff9a9947d17929d43$exports = JSON.parse("{\"Clear search\":\"Vymazat hledání\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/da-DK.json
var $da32ba9106416d52b16c583a45ca20$exports = {};
$da32ba9106416d52b16c583a45ca20$exports = JSON.parse("{\"Clear search\":\"Slet søgning\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/de-DE.json
var $ea905b03de29a1cd063923b54dea6bcf$exports = {};
$ea905b03de29a1cd063923b54dea6bcf$exports = JSON.parse("{\"Clear search\":\"Suche löschen\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/el-GR.json
var $daed949fc0db10c58debfb4fa7f17839$exports = {};
$daed949fc0db10c58debfb4fa7f17839$exports = JSON.parse("{\"Clear search\":\"Απαλοιφή αναζήτησης\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/en-US.json
var $af0f5c69fff20af61a0cdf3e$exports = {};
$af0f5c69fff20af61a0cdf3e$exports = JSON.parse("{\"Clear search\":\"Clear search\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/es-ES.json
var $a1995547934eb66ce808415612452f$exports = {};
$a1995547934eb66ce808415612452f$exports = JSON.parse("{\"Clear search\":\"Borrar búsqueda\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/et-EE.json
var $c7eb6e0dae2a4f27b72fca839a781c2$exports = {};
$c7eb6e0dae2a4f27b72fca839a781c2$exports = JSON.parse("{\"Clear search\":\"Tühjenda otsing\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/fi-FI.json
var $e6d2cdaa018f3503a5bd8910f90a1d56$exports = {};
$e6d2cdaa018f3503a5bd8910f90a1d56$exports = JSON.parse("{\"Clear search\":\"Tyhjennä haku\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/fr-FR.json
var $b7769b82bcf7bb06de27959b4410c$exports = {};
$b7769b82bcf7bb06de27959b4410c$exports = JSON.parse("{\"Clear search\":\"Effacer la recherche\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/he-IL.json
var $bdb56ce77a6ab25f6047d0dab2beb60c$exports = {};
$bdb56ce77a6ab25f6047d0dab2beb60c$exports = JSON.parse("{\"Clear search\":\"נקה חיפוש\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/hr-HR.json
var $ace56789d45e27d3d53795188b1d5a93$exports = {};
$ace56789d45e27d3d53795188b1d5a93$exports = JSON.parse("{\"Clear search\":\"Obriši pretragu\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/hu-HU.json
var $fc59075155a2f6b652e46$exports = {};
$fc59075155a2f6b652e46$exports = JSON.parse("{\"Clear search\":\"Keresés törlése\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/it-IT.json
var $f858474f7c7dab436b4cc3993ede1$exports = {};
$f858474f7c7dab436b4cc3993ede1$exports = JSON.parse("{\"Clear search\":\"Azzera ricerca\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/ja-JP.json
var $b52a078c5057ed6d3e1e814eee2$exports = {};
$b52a078c5057ed6d3e1e814eee2$exports = JSON.parse("{\"Clear search\":\"検索をクリア\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/ko-KR.json
var $b557ad6b56468a4bfc49883b07f5a57$exports = {};
$b557ad6b56468a4bfc49883b07f5a57$exports = JSON.parse("{\"Clear search\":\"검색 지우기\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/lt-LT.json
var $ff1f3622c82cf2643d701ab2aa$exports = {};
$ff1f3622c82cf2643d701ab2aa$exports = JSON.parse("{\"Clear search\":\"Išvalyti iešką\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/lv-LV.json
var $a38897a181f5c37e939dfe41e80e501$exports = {};
$a38897a181f5c37e939dfe41e80e501$exports = JSON.parse("{\"Clear search\":\"Notīrīt meklēšanu\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/nb-NO.json
var $b38db701175614a85ea9e481774dce2$exports = {};
$b38db701175614a85ea9e481774dce2$exports = JSON.parse("{\"Clear search\":\"Fjern søk\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/nl-NL.json
var $c1f9ea492258f72364c6d1941bf3e4$exports = {};
$c1f9ea492258f72364c6d1941bf3e4$exports = JSON.parse("{\"Clear search\":\"Zoekopdracht wissen\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/pl-PL.json
var $f574c74530a1f1d0eb81cba8a23e7882$exports = {};
$f574c74530a1f1d0eb81cba8a23e7882$exports = JSON.parse("{\"Clear search\":\"Wyczyść wyniki wyszukiwania\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/pt-BR.json
var $ce28b6672ee8aca4347980b3aa12066$exports = {};
$ce28b6672ee8aca4347980b3aa12066$exports = JSON.parse("{\"Clear search\":\"Limpar busca\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/ro-RO.json
var $a82ba69033bd745c85c6b521f4d3a3$exports = {};
$a82ba69033bd745c85c6b521f4d3a3$exports = JSON.parse("{\"Clear search\":\"Ştergeţi căutarea\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/ru-RU.json
var $f3265cc8dad0f06b76bc2fe6b732e63$exports = {};
$f3265cc8dad0f06b76bc2fe6b732e63$exports = JSON.parse("{\"Clear search\":\"Очистить поиск\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/sk-SK.json
var $e9afe7bc68200f921b2057f143805217$exports = {};
$e9afe7bc68200f921b2057f143805217$exports = JSON.parse("{\"Clear search\":\"Vymazať vyhľadávanie\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/sl-SI.json
var $c4cfac75f686aaee92334c2a5227326$exports = {};
$c4cfac75f686aaee92334c2a5227326$exports = JSON.parse("{\"Clear search\":\"Počisti iskanje\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/sr-SP.json
var $ed40ac41e385f37a08a72451557baa9$exports = {};
$ed40ac41e385f37a08a72451557baa9$exports = JSON.parse("{\"Clear search\":\"Obriši pretragu\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/sv-SE.json
var $fa43b7ff6adb018824a45baf4be6797$exports = {};
$fa43b7ff6adb018824a45baf4be6797$exports = JSON.parse("{\"Clear search\":\"Rensa sökningen\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/tr-TR.json
var $fa67968fb2f6b3e03325b2c7fc3c4a1$exports = {};
$fa67968fb2f6b3e03325b2c7fc3c4a1$exports = JSON.parse("{\"Clear search\":\"Aramayı temizle\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/uk-UA.json
var $c8b1b30d721b8cc231d775ab0f7a65b$exports = {};
$c8b1b30d721b8cc231d775ab0f7a65b$exports = JSON.parse("{\"Clear search\":\"Очистити пошук\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/zh-CN.json
var $dd5d322be6e0709582ec0d5406c160e7$exports = {};
$dd5d322be6e0709582ec0d5406c160e7$exports = JSON.parse("{\"Clear search\":\"清除搜索\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/zh-TW.json
var $b523e589398b2a2e082862f2d4c53670$exports = {};
$b523e589398b2a2e082862f2d4c53670$exports = JSON.parse("{\"Clear search\":\"清除搜尋\"}");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
// @ts-ignore
const $b631bb1469418f21f40483e76ae$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersEsmInteropRequireDefault($c76317fc87652827db860fd78f41091$exports).default,
  "bg-BG": _babelRuntimeHelpersEsmInteropRequireDefault($bdebbfdf67af8a25a6f22f0c45d8bf69$exports).default,
  "cs-CZ": _babelRuntimeHelpersEsmInteropRequireDefault($dfe8bbb903ff9a9947d17929d43$exports).default,
  "da-DK": _babelRuntimeHelpersEsmInteropRequireDefault($da32ba9106416d52b16c583a45ca20$exports).default,
  "de-DE": _babelRuntimeHelpersEsmInteropRequireDefault($ea905b03de29a1cd063923b54dea6bcf$exports).default,
  "el-GR": _babelRuntimeHelpersEsmInteropRequireDefault($daed949fc0db10c58debfb4fa7f17839$exports).default,
  "en-US": _babelRuntimeHelpersEsmInteropRequireDefault($af0f5c69fff20af61a0cdf3e$exports).default,
  "es-ES": _babelRuntimeHelpersEsmInteropRequireDefault($a1995547934eb66ce808415612452f$exports).default,
  "et-EE": _babelRuntimeHelpersEsmInteropRequireDefault($c7eb6e0dae2a4f27b72fca839a781c2$exports).default,
  "fi-FI": _babelRuntimeHelpersEsmInteropRequireDefault($e6d2cdaa018f3503a5bd8910f90a1d56$exports).default,
  "fr-FR": _babelRuntimeHelpersEsmInteropRequireDefault($b7769b82bcf7bb06de27959b4410c$exports).default,
  "he-IL": _babelRuntimeHelpersEsmInteropRequireDefault($bdb56ce77a6ab25f6047d0dab2beb60c$exports).default,
  "hr-HR": _babelRuntimeHelpersEsmInteropRequireDefault($ace56789d45e27d3d53795188b1d5a93$exports).default,
  "hu-HU": _babelRuntimeHelpersEsmInteropRequireDefault($fc59075155a2f6b652e46$exports).default,
  "it-IT": _babelRuntimeHelpersEsmInteropRequireDefault($f858474f7c7dab436b4cc3993ede1$exports).default,
  "ja-JP": _babelRuntimeHelpersEsmInteropRequireDefault($b52a078c5057ed6d3e1e814eee2$exports).default,
  "ko-KR": _babelRuntimeHelpersEsmInteropRequireDefault($b557ad6b56468a4bfc49883b07f5a57$exports).default,
  "lt-LT": _babelRuntimeHelpersEsmInteropRequireDefault($ff1f3622c82cf2643d701ab2aa$exports).default,
  "lv-LV": _babelRuntimeHelpersEsmInteropRequireDefault($a38897a181f5c37e939dfe41e80e501$exports).default,
  "nb-NO": _babelRuntimeHelpersEsmInteropRequireDefault($b38db701175614a85ea9e481774dce2$exports).default,
  "nl-NL": _babelRuntimeHelpersEsmInteropRequireDefault($c1f9ea492258f72364c6d1941bf3e4$exports).default,
  "pl-PL": _babelRuntimeHelpersEsmInteropRequireDefault($f574c74530a1f1d0eb81cba8a23e7882$exports).default,
  "pt-BR": _babelRuntimeHelpersEsmInteropRequireDefault($ce28b6672ee8aca4347980b3aa12066$exports).default,
  "ro-RO": _babelRuntimeHelpersEsmInteropRequireDefault($a82ba69033bd745c85c6b521f4d3a3$exports).default,
  "ru-RU": _babelRuntimeHelpersEsmInteropRequireDefault($f3265cc8dad0f06b76bc2fe6b732e63$exports).default,
  "sk-SK": _babelRuntimeHelpersEsmInteropRequireDefault($e9afe7bc68200f921b2057f143805217$exports).default,
  "sl-SI": _babelRuntimeHelpersEsmInteropRequireDefault($c4cfac75f686aaee92334c2a5227326$exports).default,
  "sr-SP": _babelRuntimeHelpersEsmInteropRequireDefault($ed40ac41e385f37a08a72451557baa9$exports).default,
  "sv-SE": _babelRuntimeHelpersEsmInteropRequireDefault($fa43b7ff6adb018824a45baf4be6797$exports).default,
  "tr-TR": _babelRuntimeHelpersEsmInteropRequireDefault($fa67968fb2f6b3e03325b2c7fc3c4a1$exports).default,
  "uk-UA": _babelRuntimeHelpersEsmInteropRequireDefault($c8b1b30d721b8cc231d775ab0f7a65b$exports).default,
  "zh-CN": _babelRuntimeHelpersEsmInteropRequireDefault($dd5d322be6e0709582ec0d5406c160e7$exports).default,
  "zh-TW": _babelRuntimeHelpersEsmInteropRequireDefault($b523e589398b2a2e082862f2d4c53670$exports).default
};

/**
 * Provides the behavior and accessibility implementation for a search field.
 * @param props - Props for the search field.
 * @param state - State for the search field, as returned by `useSearchFieldState`.
 * @param inputRef - A ref to the input element.
 */
export function useSearchField(props, state, inputRef) {
  let formatMessage = useMessageFormatter($b631bb1469418f21f40483e76ae$var$intlMessages);
  let {
    isDisabled,
    onSubmit = () => {},
    onClear,
    type = 'search'
  } = props;

  let onKeyDown = e => {
    const key = e.key;

    if (key === 'Enter' || key === 'Escape') {
      e.preventDefault();
    }

    if (isDisabled) {
      return;
    }

    if (key === 'Enter') {
      onSubmit(state.value);
    }

    if (key === 'Escape') {
      state.setValue('');

      if (onClear) {
        onClear();
      }
    }
  };

  let onClearButtonClick = () => {
    state.setValue('');

    if (onClear) {
      onClear();
    }
  };

  let onPressStart = () => {
    // this is in PressStart for mobile so that touching the clear button doesn't remove focus from
    // the input and close the keyboard
    inputRef.current.focus();
  };

  let {
    labelProps,
    inputProps
  } = useTextField(_babelRuntimeHelpersEsmExtends({}, props, {
    value: state.value,
    onChange: state.setValue,
    onKeyDown,
    type
  }), inputRef);
  return {
    labelProps,
    inputProps: _babelRuntimeHelpersEsmExtends({}, inputProps, {
      // already handled by useSearchFieldState
      defaultValue: undefined
    }),
    clearButtonProps: {
      'aria-label': formatMessage('Clear search'),
      excludeFromTabOrder: true,
      onPress: onClearButtonClick,
      onPressStart
    }
  };
}
//# sourceMappingURL=module.js.map
